// @ts-check
import React from 'react';

import GlobalIcon from '@liquidweb-dev/undercurrent/icons/lucide/Globe';
import SettingsIcon from '@liquidweb-dev/undercurrent/icons/lucide/Settings';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import NavLink from 'components/NavLinkSub';
import SettingsLayoutContainer from 'pages/servers/Settings/SettingsLayoutContainer';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 */
const VmWareVdcSettingsLayout = ({ children }) => {
	/** @type {{ uniqId: string }} */
	const { uniqId } = useParams();
	const { pathname } = useLocation();

	return (
		<SettingsLayoutContainer>
			<Stack component="nav" sx={{ gap: 50 }}>
				<NavLink
					active={pathname === `/servers/${uniqId}/vmware-vdc/settings`}
					component={RouterLink}
					// @ts-expect-error
					to={`/servers/${uniqId}/vmware-vdc/settings`}
					startIcon={<SettingsIcon />}
				>
					General
				</NavLink>
				<NavLink
					active={pathname === `/servers/${uniqId}/vmware-vdc/settings/ips`}
					component={RouterLink}
					// @ts-expect-error
					to={`/servers/${uniqId}/vmware-vdc/settings/ips`}
					startIcon={<GlobalIcon />}
				>
					IP addresses
				</NavLink>
			</Stack>

			{children}
		</SettingsLayoutContainer>
	);
};

export default VmWareVdcSettingsLayout;
